/*
 * @Author: Dong
 * @Date: 2022-04-07 13:22:58
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-03-16 10:43:00
 */
import React, { createRef, useState, forwardRef, useEffect } from 'react';
import { useIntl } from 'react-intl';
import Icon from 'root/components/Icon';
import FormItem from './Form';
import messages from './messages';
import styles from './index.less';
import { FormComponentProps } from 'sup-ui/lib/form';
import SupTable from 'sup-rc-table';
import { Select, Form } from 'sup-ui';
import { reducerStates } from 'root/store/types';
import { selectNodeVersion, setInstallType } from 'root/store/nodeConfig/actions';
import { useSelector, useDispatch } from 'react-redux';

interface PropsType extends FormComponentProps {
  name: string;
  nodeList: any;
  count: number;
  total: number;
  options: any;
  existingServicesFrom: any[];
  deployMode: { deployName: string; mode: number }[];
}
const { Option } = Select;

const NodeItem = forwardRef<FormComponentProps, PropsType>((props) => {
  const { name, nodeList, count, total, form, options, existingServicesFrom, deployMode } = props;

  const intl = useIntl();
  const dispatch = useDispatch();
  const formRef = createRef<FormComponentProps>();
  const [visible, setVisible] = useState(false);
  const { nodeVersions, installationType } = useSelector((state: reducerStates) => state.nodeConfig);

  const [formData, setFormData] = useState<any>([]);
  const [type, setType] = useState(1);
  const [typeLabel, setTypeLabel] = useState('');
  const [versionLabel, setVersionLabel] = useState('');

  const roleConfig = () => {};
  const { getFieldDecorator } = form;

  const columns = [
    {
      title: intl.formatMessage(messages.nodeName),
      dataIndex: 'hostName',
      width: 120,
    },
    {
      title: 'IP',
      dataIndex: 'ip',
      width: 120,
    },
    {
      title: 'CPU',
      dataIndex: 'cpuLimit',
      width: 80,
    },

    {
      title: intl.formatMessage(messages.memory),
      dataIndex: 'memoryLimit',
      width: 80,

      render: (text: string) => <span>{text}</span>,
    },
    {
      title: intl.formatMessage(messages.disk),
      dataIndex: 'diskLimit',
      width: 80,
    },
    {
      title: intl.formatMessage(messages.tag),
      dataIndex: 'labels',
      width: 80,
      render: (text: string) => <span>{text}</span>,
    },
    {
      title: intl.formatMessage(messages.roleCOnfig),
      dataIndex: 'operate',
      width: 80,
      render: () => {
        return (
          <div className={`${styles.edit}`} onClick={() => roleConfig()}>
            admin
          </div>
        );
      },
    },
  ];

  // 收集上传列表中的必填版本的选择
  useEffect(() => {
    const initMode = installationType[name] || deployMode[0].mode;

    dispatch(setInstallType({ [name]: initMode }));
    changeType(initMode);
    handleChange(nodeVersions[name] || options[0]?.id || name);

    if (!window.nodeForms) {
      window.nodeForms = {};
    }

    window.nodeForms[name] = form;
    return () => {
      delete window.nodeForms[name];
    };
  }, []);

  const toggle = () => {
    setVisible(!visible);
  };

  // 切换版本
  const handleChange = (value: string) => {
    dispatch(selectNodeVersion({ [name]: value }));
    const data = options.filter((item: any) => item.id === value);

    if (data.length) {
      setFormData(data[0].form);
      setVersionLabel(data[0].version);
    }
  };

  // 切换部署方式
  const changeType = (value: string | number) => {
    const val = Number(value);
    setType(val);
    dispatch(setInstallType({ [name]: val }));
    const data = deployMode.filter((item: any) => item.mode === val);
    if (data.length) {
      setTypeLabel(data[0].deployName);
    }
  };

  return (
    <div className={styles.nodeItem}>
      <div className={styles.header}>
        <div className={styles.flex}>
          <p className={styles.block}>{name}</p>
          <h3 className={styles.count}>
            <i> {name}</i> ({count}/{total})
          </h3>
        </div>
        <div className={styles.flex}>
          <Form labelCol={{ span: 8 }} wrapperCol={{ span: 16 }} className={styles.form}>
            <Form.Item label={intl.formatMessage(messages.type)}>
              {getFieldDecorator('type', {
                initialValue: typeLabel,
                rules: [
                  {
                    required: true,
                    message: intl.formatMessage(messages.requiredNull),
                  },
                ],
              })(
                <Select style={{ width: 150 }} onChange={changeType}>
                  {deployMode.map((item: any) => {
                    const { deployName, mode } = item;

                    return (
                      <Option key={mode} value={mode}>
                        {deployName}
                      </Option>
                    );
                  })}
                </Select>,
              )}
            </Form.Item>
            {type === 1 && (
              <Form.Item label={intl.formatMessage(messages.version)} style={{ width: '260px' }}>
                {getFieldDecorator('version', {
                  initialValue: versionLabel,
                  rules: [
                    {
                      required: true,
                      message: intl.formatMessage(messages.requiredNull),
                    },
                  ],
                })(
                  <Select style={{ width: 180 }} onChange={handleChange}>
                    {(options || []).map((item: any) => {
                      const { version, id } = item;

                      return (
                        <Option key={id} value={id}>
                          {version}
                        </Option>
                      );
                    })}
                  </Select>,
                )}
              </Form.Item>
            )}
          </Form>

          <span onClick={toggle} className={styles.detail}>
            {intl.formatMessage(messages.detail)}
            <Icon type={visible ? 'bluearrow16_up' : 'bluearrow16_down'} className={styles.arrowIcon} />
          </span>
        </div>
      </div>

      {visible && (
        <div>
          {nodeList && nodeList.length !== 0 && (
            <div className={styles.nodeList}>
              <h3 className={styles.title}>{intl.formatMessage(messages.nodeList)}</h3>
              <SupTable
                columns={columns}
                dataSource={nodeList}
                rowKey="name"
                showSelection={false}
                showSearchIcon={false}
                showColumnsFilter={false}
              />
            </div>
          )}
        </div>
      )}
      {((type === 1 && formData && formData.length !== 0) || (existingServicesFrom && type === 3)) && (
        <FormItem name={name} wrappedComponentRef={formRef} dataSource={type === 1 ? formData : existingServicesFrom} />
      )}
    </div>
  );
});

export default Form.create()(NodeItem);
